import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import useFlashSale from 'views/rebranded-module/deals-module/DealDetailsViewV2/hooks/useFlashSale';
import StyledBox from 'views/rebranded-module/deals-module/DealDetailsViewV2/components/FlashSaleSection/FlashSaleSection.styles';

interface FlashSaleProps {
  flashSaleEndTime: string;
  flashSaleText: string;
  disabled?: boolean;
}
const FlashSaleSection: FC<FlashSaleProps> = (props) => {
  const { flashSaleEndTime, flashSaleText, disabled } = props;
  
   const [enableSale, timeLeft] = useFlashSale({
    flashSaleEnabled: true,
    flashSaleEndTime
  });
  return (
    <>
      {enableSale && (
        <StyledBox className={disabled && 'FSSDisabled'}>
          <Typography variant="body1" component="h4" mb={1}>
            {flashSaleText}
          </Typography>
            {timeLeft.map((item) => (
              <Box className="FSSRemaintime" key={item.text}>
                <Typography
                  variant="h7"
                  component="p"
                  className="FSSSeparetor">
                  {item.num}
                </Typography>
                <Typography variant="overline3" component="p" className='FSSLabel'>
                  {item.text}
                </Typography>
                </Box>
            ))}
        </StyledBox>
      )}
    </>
  );
};

export { FlashSaleSection };
